module.exports = __webpack_public_path__ + "img/ozon-logo.613df516.png";